module Meevo.Plugins.Product {
    class ProductSalesAndActivityController {
        static $inject = [
            "meevo.components.common.DataService",
            "meevo.AppSettings", 
            "variantsDrilledInto", 
            "variantId",
            "parentController",
            "$timeout",
            "$translate", 
            "meevoDateFilterFilter",
            "$mdBottomSheet"
        ];
        public product : Meevo.Model.Product;
        public variant;
        public saleDataFetched: boolean;
        public fetchingData: boolean;
        public criteria;
        public activeTabIndex;
        public locationStartYear;
        public currentYear = new Date().getFullYear();
        public currentMonth = new Date().getMonth() + 1;
        public yearSelect: any = [];
        public salesDateRange: any;
        private localStorageKey: string = "";

        constructor(
            public dataService: Meevo.Components.BaseClasses.IDataService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            public variantsDrilledInto: Meevo.Model.Variant[],
            public variantId: any,
            public parentController: Meevo.Plugins.Product.ProductInformationController,
            public $timeout: angular.ITimeoutService,
            public $translate: ng.translate.ITranslateService,
            public meevoDateFilter: any,
            public $mdBottomSheet: angular.material.IBottomSheetService) {
            
            
            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/Tenant/Businessinfo`, 'GET', null).then((res: any) => {
                this.locationStartYear = res.data && res.data.implementationDate ? moment(res.data.implementationDate).year() : this.currentYear - 1;
                if (this.locationStartYear > this.currentYear - 5) {
                    this.locationStartYear = this.currentYear - 5;
                }
                for(var y = this.currentYear - 1; y >= this.locationStartYear; y--) {
                    this.yearSelect.push(y);
                }
            });
            
            console.log('PRODUCT SALES SHEET', this);
            this.activeTabIndex = this.variantsDrilledInto.findIndex(x => x.id == this.variantId);
            if (this.activeTabIndex == -1) {
                this.activeTabIndex = this.variantsDrilledInto.length - 1;    
            }
            this.localStorageKey = `meevo2.products.${this.parentController.identityService.current().tenantId}.${this.parentController.identityService.current().locationId}`;
        }

        $onInit() {
            var dialog = $('md-dialog');
            if (dialog) {
                dialog.scrollTop(0);
                dialog.addClass('overflow-hidden');
            }
        }

        formatSalesMonths(results) : any {
            return results.map(obj => {
                return {...obj, saleMonth : moment(obj.saleMonth).format("MMM")}
            });
        }

        changedSalesDateRange(item : Meevo.Model.Variant) : void {
            if (this.variantsDrilledInto[this.activeTabIndex].sales[item.salesDateRange]) return;

            try {
                var productData = JSON.parse(localStorage.getItem(this.localStorageKey));
                if (productData && productData[item.id + item.productInventoryType] && productData[item.id + item.productInventoryType][item.salesDateRange]) {
                    var results = productData[item.id + item.productInventoryType][item.salesDateRange];
                    results = this.formatSalesMonths(results);
                    this.variantsDrilledInto[this.activeTabIndex].sales[item.salesDateRange] = results;
                    return;
                }    
            } catch (error) { }
            

            var basisDate;
            if (item.salesDateRange > 0) { 
                basisDate = moment(new Date(item.salesDateRange, 1, 1)).startOf('year');
                item.salesStartDate = basisDate.toDate();
                item.salesEndDate = moment(item.salesStartDate).endOf('year').toDate();
            } else { // last 12 months
                basisDate = moment().startOf('month');
                item.salesEndDate = basisDate.toDate();
                item.salesStartDate = moment(item.salesEndDate).subtract(11, 'months',).toDate()
            }
            this.fetchingData = true;
            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/product/${item.id}/SalesAndActivity?startDate=${moment(item.salesStartDate).format("YYYY-MM-DD")}&endDate=${moment(item.salesEndDate).format("YYYY-MM-DD")}&productInventoryTypeEnum=${item.productInventoryType}&includeActivity=false&includeSales=${this.parentController.showSalesData}`, 'GET', null).then((response) => {
                this.fetchingData = false;
                if (response && response.data) {
                    if (response.data.sales) {
                        if (item.salesDateRange > 0) {
                            // sort dates the other way for options other than Last 12 Months
                            response.data.sales = response.data.sales.reverse() 
                            this.handleLocalStorage(item, response.data.sales)
                        }
                        response.data.sales = this.formatSalesMonths(response.data.sales);
                        
                        item.sales[item.salesDateRange] = response.data.sales;
                    }
                }    
            });
            
        }

        handleLocalStorage(item : Model.Variant, sales) : void {
            if (!item || !sales) return;
            if (item.salesDateRange > 0) {
                var productData = {};
                try {
                    var localData = JSON.parse(localStorage.getItem(this.localStorageKey));
                    if (localData) {
                        productData = localData;
                        productData[item.id + item.productInventoryType][item.salesDateRange] = sales;
                    } else {
                        throw null;
                    }
                } catch (error) {
                    var newRange = {}
                    newRange[item.salesDateRange] = sales;
                    productData[item.id + item.productInventoryType] = newRange;
                }
                localStorage.setItem(this.localStorageKey, JSON.stringify(productData));
            }
        }

        isShopSupply(variant: Meevo.Model.Variant) : boolean {
            return variant.productInventoryType == Meevo.Model.ProductInventoryTypeEnum.ShopSupply;
        }

        getTabTitle(item: Meevo.Model.Variant) : string {
            if (item.variantAttributes.length > 0) {
                var results = item.sku + " : ";
                for (var x = 0; x < item.variantAttributes.length; x++) {
                    results = results + item.variantAttributes[x].displayName.toString().replaceAll(",", "") + " ";
                }
                return results.trim();
            } else {
                return item.displayName;
                
            }
        }

        getCurrentYearHeight(item: Model.Variant): any {
            return item.salesDateRange > 0 
                ? { "height": "auto" }
                : { "height": this.currentMonth < 12 ? (this.currentMonth * 25 - 1) + "px" : "100%" };
        }

        close() : void {
            this.$mdBottomSheet.hide();
        }

       showAltClose() : boolean {
        var backdrop = $('.md-bottom-sheet-backdrop')[0];
        var bottomSheet = $('.variant-activity-section')[0];
        return !backdrop || !bottomSheet ? false : backdrop.offsetHeight - 60 <= bottomSheet.offsetHeight;
       }

    }

    angular.module("meevo.plugins.product")
        .controller("meevo.plugins.product.ProductSalesAndActivityController", ProductSalesAndActivityController);
}
